import * as React from 'react';
import { SVGProps } from 'react';

const SvgSearchOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m16.289 14.94 4.437 4.455a.926.926 0 0 1-.027 1.34.995.995 0 0 1-.68.265.992.992 0 0 1-.708-.29l-4.47-4.49a7.632 7.632 0 0 1-4.313 1.315C6.377 17.535 3 14.275 3 10.267 3 6.26 6.377 3 10.527 3c4.151 0 7.528 3.26 7.528 7.268a7.095 7.095 0 0 1-1.766 4.671Zm-.198-4.672c0-2.962-2.496-5.372-5.564-5.372-3.067 0-5.563 2.41-5.563 5.372 0 2.961 2.496 5.371 5.563 5.371 3.069 0 5.564-2.41 5.564-5.371Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgSearchOutlined;
